export default '/build/b1235154.svg'